var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 19.5V5.333H15.833a2.494 2.494 0 0 0-2.5 2.5v48.334c0 1.385 1.115 2.5 2.5 2.5h35c1.386 0 2.5-1.115 2.5-2.5V22H39.167a2.507 2.507 0 0 1-2.5-2.5zm6.26 11.094-6.26 9.74 6.26 9.739c.531.833-.062 1.927-1.052 1.927H38.24c-.459 0-.886-.25-1.105-.656a546.114 546.114 0 0 1-3.802-7.157c-.666 1.542-1.041 2.084-3.812 7.167a1.238 1.238 0 0 1-1.094.656h-3.635c-.99 0-1.584-1.093-1.052-1.927l6.28-9.74-6.28-9.739c-.542-.833.062-1.927 1.052-1.927h3.625c.458 0 .885.25 1.104.656 2.719 5.084 2.083 3.5 3.812 7.136 0 0 .636-1.219 3.813-7.136a1.255 1.255 0 0 1 1.104-.656h3.625c.99-.01 1.583 1.083 1.052 1.917zM53.333 18.03v.636H40V5.333h.635c.667 0 1.303.26 1.771.73L52.604 16.27c.469.469.73 1.104.73 1.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon_excel.a1a5e424f68a4e62b1600de5add8f390.svg";
export { ForwardRef as ReactComponent };